<template>
  <div class="inside_wrapper">
    <el-divider content-position="left" class="no-print">准考证</el-divider>
    <div v-if="!ticket">
      <el-empty :image-size="200" description="暂无数据"></el-empty>
    </div>
    <div v-else class="ticket_wrapper" ref="html">
      <div class="ticket_tit">
        <div style="padding:10px">
          <h3>南充电影工业职业学院</h3>
          <h3 style="margin-top:10px">{{yeah}}年高职单招考试准考证</h3>
        </div>
      </div>
      <div class="ticket_body">
        <div class="ticket_body_top">
          <div class="avatar_left">
            <div class="name_wrapper">
              <div class="name_wrapper_left">
                <div class="name">
                  <div class="name_title">姓名：</div>
                  <div class="ticket_con">{{ticket.Name}}</div>
                </div>
              </div>
              <div class="name_wrapper_right">
                <div class="sex">
                  <div class="sex_title">性别：</div>
                  <div class="ticket_con">{{ticket.Sex}}</div>
                </div>
              </div>

            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">身份证号：</div>
                <div class="ticket_con">{{ticket.CardNumber}}</div>
            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">准考证号：</div>
                <div class="ticket_con">{{ticket.Number}}</div>
            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">专业名称：</div>
                <div class="ticket_con">{{ticket.MajorName}}</div>
            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">考生类别：</div>
                <div class="ticket_con">{{ticket.Type}}</div>
            </div>
          </div>
          <div class="avatar_right">
            <img :src="baseUrl + ticket.Icon" alt="">
          </div>
        </div>
        <div class="ticket_body_bottom">
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title" style="line-height:4.5">考试科目及时间：</div>
                <div class="ticket_con" style="padding:0">
                  <div class="card_num ticket_item_wrapper">
                      <div class="ticket_title" style="padding:3px 10px;">文化知识综合笔试</div>
                      <div class="ticket_con" style="padding:3px 10px;">{{ticket.WriteExamTime}}</div>
                  </div>
                  <div class="card_num ticket_item_wrapper">
                      <div class="ticket_title" style="padding:3px 10px; border-bottom:none">技能综合测试</div>
                      <div class="ticket_con"  style="padding:3px 10px; border-bottom:none">{{ticket.InterviewTime}}</div>
                  </div>
                </div>
            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">候考室：</div>
                <div class="ticket_con">{{ticket.Address}}</div>
            </div>
            <div class="card_num ticket_item_wrapper">
                <div class="ticket_title">面试地点：</div>
                <div class="ticket_con">{{ticket.Room}}</div>
            </div>
        </div>
      </div>
    </div>
    <div style="text-align:right; width:600px; margin:30px auto"  v-if="ticket">
      <!-- <router-link tag="a" target="_blank" to="/ticket_result"><el-button type="primary" @click="handlePrint">打印</el-button></router-link> -->
      <el-button  type="primary" @click="handlePrint">打印</el-button>
    </div>

    <div class="my-notice">
      <div class="my-notice-title">单招考试须知</div>
      <div class="my-notice-con">
（一）考生参加文化考试、综合素质测试时必须携带准考证和身份证原件、健康情况承诺书、48小时核酸检测报告参加考试。<br/>
（二）为增强防疫意识，考生须佩戴口罩，防治社交感染。<br/>
（三）考生必须按时抵达考场，迟到15分钟视为弃考，考试过程中不能离开考场，不能提前交卷。<br/>
（四）考试过程中，考生应服从考点监考考试工作人员管理，遵纪守法，诚信考试。<br/>
（五）考生应携带黑色钢笔或签字笔、2B铅笔进入考场，考生不能将书籍、手机等物品带入考场。
      </div>
    </div>
    <div class="fujian">
      附件为健康情况承诺书，请下载打印一起携带：<a href="http://school.duzhitech.cn/Uploads/2021/202103/%E5%81%A5%E5%BA%B7%E6%83%85%E5%86%B5%E6%89%BF%E8%AF%BA%E4%B9%A6.docx"><el-button type="danger" >点击下载承诺书</el-button></a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent,ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import useWrapper from "./useTicket"
import {useStore} from "vuex"

export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const router = useRouter()
    const html = ref(null)
    const store = useStore()
    const baseUrl = process.env.VUE_APP_BASE_URL
    const {rawData,getTicket} = useWrapper()
    const d = new Date();
    const yeah = d.getFullYear()
    //*********** definning variables end **********//
    //*********** initData start **********//
    // if(store.state.userInfo.IsSure){
    //   getTicket()
    // }
    getTicket()
    
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    function handlePrint(){
      router.push({path:'/ticket_result'})
    }
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),
      handlePrint,html,baseUrl,yeah
      }
  },
});
</script>
<style lang="scss">
.ticket_wrapper{width: 600px; border: 1px solid #333; margin: 0 auto; border-bottom: none;
  .ticket_tit{text-align: center; border-bottom: 1px solid #333;}
  .ticket_body{text-align: right; line-height: 2; box-sizing: border-box;
    .ticket_body_top{display: flex;}
    .avatar_left{flex: 0 0 469px;
      
    }
    .avatar_right{flex: 1; padding: 5px;
      img{width: 100%; height: 100%;}
    }
  }
  .name_wrapper{display: flex;
    .name_wrapper_left{flex: 0 0 60%;
      .name{display: flex;
        .name_title{flex: 0 0 140px; border-bottom: 1px solid #333; border-right: 1px solid #333; padding: 3px 0px;}
        .ticket_con{flex: 1; border-bottom: 1px solid #333; border-right: 1px solid #333; padding: 3px 10px; text-align: left;}
      }

    }
    .name_wrapper_right{flex: 0 0 40%;
      .sex{display: flex;
        .sex_title{flex: 0 0 50%; border-bottom: 1px solid #333; border-right: 1px solid #333;padding: 3px 0px;}
        .ticket_con{flex: 1; border-bottom: 1px solid #333; padding: 3px 10px; text-align: left;}
      }
    }
  }
  .sex{flex: 0 0 40%;}
  .ticket_item_wrapper{display: flex;
    .ticket_title{text-align: right; border-bottom: 1px solid #333; border-right: 1px solid #333; flex: 0 0 140px;padding: 3px 0px;}
    .ticket_con{border-bottom: 1px solid #333; flex: 1; padding: 3px 10px; text-align: left;}

  }
  .avatar_right{border-bottom: 1px solid #333; border-left: 1px solid #333;}
}
.my-notice-title{line-height: 2; font-weight: bold; text-align: center; font-size: 18px;}
.my-notice-con{line-height: 2; color: #666; width: 70%; margin: 0 auto;}
.fujian{text-align: center; margin-top: 20px; color: red;}
@media print {
  .no-print {
    display: none;
  }
}
</style>
